import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { initWebMonitoring } from './app/monitoring';
import { initAnalytics } from './app/analytics';

// Deliberately not awaited: the dashboard must not trade first paint for the
// config fetch. Errors thrown before init resolves are still logged to the
// console by MonitoringErrorHandler — only their remote report is lost.
void initWebMonitoring();
initAnalytics();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
